import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
   selector: 'app-telefone-dialog',
   standalone: true,
   imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
   template: `
      <div
         style="width:100%;  
        height: 100%;
        background: transparent !important;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        overflow: hidden;"
      >
         <div style="background-color: white; width: 300px">
            <h2 mat-dialog-title>Telefone da unidade</h2>

            <mat-dialog-content>
               <p>
                    <strong>{{ data.nome }}</strong>
               </p>
               <p style="display: flex; align-items: center; gap: 6px;">
                    <mat-icon style="color: #e53935">phone</mat-icon>
                    <strong>{{ data.telefone }}</strong>
               </p>
               <div *ngIf="data.linkMapa">
               <a [href]="data.linkMapa" target="_blank" title="Ver no mapa">
                  <mat-icon  style="color: #e53935">location_on</mat-icon>
                  <strong>Abrir Mapa </strong>
               </a>
               </div>
            </mat-dialog-content>
            <mat-dialog-actions align="end">
               <button mat-button mat-dialog-close>Fechar</button>
            </mat-dialog-actions>
         </div>
      </div>
   `
})
export class TelefoneDialogComponent {
   constructor(@Inject(MAT_DIALOG_DATA) public data: { nome: string; telefone: string; linkMapa?: string }) {}
}